import { makeStyles } from '@fluentui/react-components';
import { Color } from 'libs/theme/src/lib/colors';
import { ThemeFontFamily } from 'libs/theme/src/lib/theme-fontfamily';

export const rulesStyles = makeStyles({
  row: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: '1rem',

    '> *': {
      minWidth: '15.2rem',
      flex: 1,
    },
  },

  rulesContainer: {
    fontFamily: ThemeFontFamily.sans,
    fontSize: '1rem',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  conditionContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  conditionGroup: {
    display: 'flex',
    gap: '76px',
    alignItems: 'center',
    width: '100%',
  },

  innerConditionGroup: {
    padding: '1rem',
    backgroundColor: 'rgba(29, 57, 196, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '16px',
    flex: 1,
    width: '100%',
  },

  innerConditionHeaderGroup: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },

  ruleConditionType: {
    marginLeft: '78px',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    padding: '4px',

    '> div': {
      padding: '8px 1rem',
      borderRadius: '4px',
    },
  },

  conditionType: {
    display: 'flex',
    backgroundColor: Color.white,
    padding: '4px',

    '> div': {
      padding: '8px 1rem',
      borderRadius: '4px',
    },
  },

  activeConditionType: {
    backgroundColor: Color.background_dark_blue_quiz,
    color: Color.white,
  },

  conditionSettings: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    width: '100%',
  },

  flex: { flex: 1 },

  text: { fontFamily: ThemeFontFamily.sans, fontSize: '1rem' },

  addGroupBtn: {
    padding: '12px 0 12px 84px',
    display: 'flex',
    gap: '8px',
  },

  isBtnCompact: {
    padding: '12px 0 12px 0',
  },

  addGroupBtnNoItems: {},

  deleteBtn: {
    color: Color.DELETE_ICON_COLOR,
    cursor: 'pointer',
  },

  isVisibile: { visibility: 'visible', cursor: 'pointer' },

  hidden: { visibility: 'hidden' },

  groupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  ruleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  inactiveConditionType: { cursor: 'pointer' },

  inactiveRuleConditionType: { backgroundColor: Color.gray_100 },

  referencePicker: { minWidth: '250px' },

  rangeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    rowGap: '14px',
    columnGap: '2px',

    '> div': {
      flex: 1,
    },
  },

  tabList: {
    borderBottom: `1px solid ${Color.gray_tab_border}`,

    display: 'flex',
    alignItems: 'center',

    '> button > span': {
      fontSize: '1rem',
    },
    minWidth: '100%',
  },

  tabInput: {
    border: 0,
    fontSize: '1rem',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis ',
    height: '32px',
    backgroundColor: 'transparent',
  },

  addIcon: {
    marginLeft: '8px',
    color: Color.blue_700,
    cursor: 'pointer',
  },

  tab: {
    padding: '8px',
  },

  innerAvailableColumn: {
    padding: '12px',
    backgroundColor: Color.background_body_bg,
    borderRadius: '7.578px',
    fontFamily: ThemeFontFamily.sans,
    gap: '8px',
    display: 'flex',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },

  outerMultipleRules: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px',
  },

  availableColumnsScrollButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0 1rem',

    height: '44px',
    backgroundColor: Color.white,

    '> button': {
      borderRadius: '50%',
      width: '36px',
      height: '36px',
    },
  },

  availableMultipleRules: {
    display: 'flex',
    gap: '8px',
    overflow: 'hidden',
    width: '100%',
  },

  scrollDivider: { height: '100%' },

  tabError: {
    borderBottom: `1px solid ${Color.error_border}`,
  },

  addConditionIcon: { color: Color.DARK_BLUE_BORDER },

  tabInputError: { '::placeholder': { color: Color.error_color } },

  disabled: {
    pointerEvents: 'none',
    cursor: 'not-drop !important',
    opacity: '0.72',
  },
});
